export default __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.338d80b0.ttf";